<template>
  <div class="tcgaExpAll">
    <clusters />
  </div>
</template>

<script>
import clusters from "./clusterTable.vue";
import Highcharts from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsDrilldown from "highcharts/modules/drilldown";
import Highcharts3D from "highcharts/highcharts-3d";
import exporting from "highcharts/modules/exporting";

HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
exporting(Highcharts);

export default {
  components: { clusters },
  data() {
    return {};
  },
  mounted() {
    this.moreChart();
  },
  methods: {
    moreChart() {
      if (this.chart) {
        this.chart.destroy();
      }
      // 初始化 Highcharts 图表
      this.chart = new Highcharts.chart("containerTCGAPaired", {
        chart: {
          type: "column",
          height: 350,
        },
        //去掉水印
        credits: {
          enabled: false,
        },
        title: {
          text: "",
        },
        subtitle: {
          text: "",
        },
        xAxis: {
          tickWidth: 2,
          tickColor: "black",
          lineWidth: 2,
          lineColor: "black",
          tickLength: 5,
          gridLineColor: "white",
          type: "category",
          labels: {
            rotation: -45, // 设置轴标签旋转角度
          },
        },
        yAxis: {
          tickWidth: 2,
          tickColor: "black",
          lineWidth: 2,
          lineColor: "black",
          tickLength: 5,
          gridLineColor: "white",
          min: 0,
          title: {
            text: "Number of cluster",
          },
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          pointFormat: "Number of cluster: <b>{point.y:.f} </b>",
        },
        series: [
          {
            name: "总人口",
            data: [
              ["SC00002", 150],
              ["SC00004", 125],
              ["SC00003", 86],
              ["SC00009", 5],
              ["SC00005", 2],
              ["SC00012", 2],
              ["SC00006", 1],
              ["SC00001", 1],
              ["SC00010", 1],
              // ["SC00007", 0],
              // ["SC00008", 0],
              // ["SC00011", 0],
            ],
            dataLabels: {
              enabled: true,
              //rotation: 90,
              color: "black",
              align: "center",
              format: "{point.y:.f}", // :.1f 为保留 1 位小数
              y: 5,
            },
          },
        ],
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit css to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
